import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import useSession from '../hooks/useSession'
import useConfig from '@/gf/hooks/useConfig'

import PathsM from '@/suppliers/modules/Paths'

const DealerHubRedirect = ({ children }) => {
  const location = useLocation()
  const config = useConfig()
  const { store } = useSession()
  const [initialized, setInitialized] = useState(false)

  const { pathname } = useLocation()
  const unauthParams = PathsM.isUnauthenticatedAllowed(
    PathsM.getAppName(window.location.origin, config),
    pathname
  )

  useEffect(() => {
    const redirectUrl = `${config.dealersUrl}${location.pathname}${
      location.search ? `?${location.search}` : ''
    }`

    if (unauthParams) {
      setInitialized(true)
    } else if (store?.dealerHubEnabled) {
      document.location.replace(redirectUrl)
    } else {
      setInitialized(true)
    }
  }, [store?.id, unauthParams])

  return initialized ? children : null
}

export default DealerHubRedirect
